export default __webpack_public_path__ + "static/media/RejectedPickupIcon.1a158219.svg";